export default __webpack_public_path__ + "static/media/something-went-wrong.663b0905.jpg";